import Router from "@/helpers/router";

import {
  WHATS_NEW_AUDIENCES,
  WHATS_NEW_ICONS,
  WhatsNewEntryI,
} from "../lib/types";

const { LGA, ADMIN } = WHATS_NEW_AUDIENCES;

/**
 * Team → EOM's checks before a lock, signed changes and month history
 * (C-16 S2 EOM improvements, GLE-8527). Its own card, not the close-tools
 * one (`2026-11-eom-close-tools.ts`): that card has been live since
 * 2026-11-01, and anyone who has seen it won't see sections added to it.
 * It ships in the frontend release that follows the backend
 * (https://github.com/goglencoco/backend/pull/7162); dark until
 * `manage/me.features.eom`. The release worker retimes `startsAt` to the
 * release (as the EOM card was, GLE-8409); each LGA and Admin sees it on
 * two ET days (C16-D425).
 */
export const EOM_CLOSE_CHECKS_2026_11: WhatsNewEntryI = {
  id: "2026-11-eom-close-checks",
  feature: "eom",
  startsAt: "2026-11-03T05:00:00.000Z",
  endsAt: "2026-12-01T05:00:00.000Z",
  title: {
    [LGA]: "Your month's history",
    [ADMIN]: "Checks before you lock, and who changed what",
  },
  intro: {
    [LGA]: "See who changed your month in EOM, when and why.",
    [ADMIN]:
      "Check a month before you lock it, sign your changes with your name, and see each month's history.",
  },
  sections: [
    {
      id: "lock-checks",
      audiences: [ADMIN],
      icon: WHATS_NEW_ICONS.HEALTH,
      title: "Before you lock",
      items: [
        "A workspace's month that has ended lists what to look at first: meetings already paid in a locked month, charges still pending, Stripe not read since the month ended, disputed meetings and more.",
        "The red ones must be ticked in the lock dialog, and the month's history keeps what was ticked. Meetings paid in a locked month can be set to not counted here in one go.",
        "On the Reconciliation table, a workspace with something to look at says how many under its status.",
      ],
      link: { label: "Open EOM", href: Router.manageEom() },
    },
    {
      id: "signing",
      audiences: [ADMIN],
      icon: WHATS_NEW_ICONS.SHIELD,
      title: "Sign your changes",
      items: [
        "Everyone in finance uses the same Admin account, so EOM asks for your name once on each browser (Signing as, top right).",
        "Every lock, payment tick, override and edit carries your name. Unlocking a month needs a reason.",
      ],
    },
    {
      id: "history",
      audiences: [LGA, ADMIN],
      icon: WHATS_NEW_ICONS.CALENDAR,
      title: "Month history",
      items: [
        "Open a workspace's month → History: who changed what, when and why, newest first.",
        "A locked month says who locked it.",
      ],
      link: { label: "Open EOM", href: Router.manageEom() },
    },
  ],
};
